import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { TranslateService } from "../../../../common/variables/translate-service";
import { SC_Input } from "../../../../common/input/SC_Input";
import { Material } from "../../../../common/utilities/Material";
import { TrapezParameter } from "../../../../common/input/TrapezParameter";
import { GlobalVariableService } from "../../../../common/variables/global-variable";
import { GlobalService } from "../../../../common/services/global.service";


@Component({
  selector: 'sen-app-mount-purlin',
  templateUrl: './mount-purlin.component.html',
  styleUrls: ['./mount-purlin.component.scss']
})
export class MountPurlinComponent implements OnInit {
  @Input() trapezCrisCross: boolean;
  @Input() vbPurlinAdditional: boolean;
  @Output() emitbSuccess = new EventEmitter;

  aPurlinMat = [
    { data: Material.WOOD, label: this.translate.getLng('MAT_WOOD') },
    { data: Material.STEEL, label: this.translate.getLng('MAT_STEEL') }
  ];
  cboPurlinMat: number;
  cboHangerBoltScrewLength: number = 130;
  cboHangerBoltData: any[];
  aTrapezSheetMat = [
    { data: Material.STEEL, label: this.translate.getLng('MAT_STEEL') },
    { data: Material.ALU, label: this.translate.getLng('MAT_ALU') }
  ];
  cboTrapezSheetMat: number;
  nsBottomChord: number = SC_Input.trapezPara.iBottomChord;
  nsTopChord: number = SC_Input.trapezPara.iTopChord;
  nsHeight: number = SC_Input.trapezPara.iProfileHeight;
  nsSize: number = SC_Input.trapezPara.iCalotteSize;

  constructor(public translate: TranslateService, public global: GlobalVariableService,
    public globalService: GlobalService) {
  }

  ngOnInit(): void {
    this.fetchInput();
    this.getHangerBolt();
  }

  fetchInput() {
    if (SC_Input.iBeamMat) {
      this.aPurlinMat.forEach(i => {
        if (i.data == SC_Input.iBeamMat) {
          this.cboPurlinMat = i.data;
        }
      });
    } else {
      this.cboPurlinMat = this.aPurlinMat[0].data;
    }
    if (SC_Input.trapezPara.iMaterial) {
      this.aTrapezSheetMat.forEach(i => {
        if (i.data == SC_Input.trapezPara.iMaterial) {
          this.cboTrapezSheetMat = i.data;
        }
      });
    } else {
      this.cboTrapezSheetMat = this.aTrapezSheetMat[0].data;
    }
    if (SC_Input.sStosch) {
      this.cboHangerBoltScrewLength = SC_Input.sStosch;
    }
  }

  public rememberInput(): void {
    if (SC_Input.iBeamMat != this.cboPurlinMat ||
      SC_Input.trapezPara.iMaterial != this.cboTrapezSheetMat ||
      SC_Input.trapezPara.iBottomChord != this.nsBottomChord ||
      SC_Input.trapezPara.iTopChord != this.nsTopChord ||
      SC_Input.trapezPara.iProfileHeight != this.nsHeight ||
      SC_Input.trapezPara.iCalotteSize != this.nsSize) {
      SC_Input.isPlanAltered = true;
    }
    SC_Input.iBeamMat = this.cboPurlinMat;
    SC_Input.trapezPara = new TrapezParameter();
    SC_Input.trapezPara.iMaterial = this.cboTrapezSheetMat;
    SC_Input.trapezPara.iBottomChord = this.nsBottomChord;
    SC_Input.trapezPara.iTopChord = this.nsTopChord;
    SC_Input.trapezPara.iProfileHeight = this.nsHeight;
    SC_Input.trapezPara.iCalotteSize = this.nsSize;
    SC_Input.sStosch = this.cboHangerBoltScrewLength;
    SC_Input.sStoschID = this.cboHangerBoltData.find(x => this.cboHangerBoltScrewLength == x.length);
  }

  setbSuccess(event: boolean) {
    this.emitbSuccess.emit(event);
  }

  getHangerBolt() {
    const qParam = {
      cmd: this.global.HangerBoltGet,
      roofType: SC_Input.iRoofType,
      purlinMaterial: this.cboPurlinMat
    };
    this.globalService.getData(qParam).subscribe((data: any) => {
      if (data && data.ok) {
        this.cboHangerBoltData = data.ok.data.hangerBolts;
      }
    });
  }

  ngOnDestroy() {
    this.rememberInput();
  }
}
